export default __webpack_public_path__ + "static/media/qr.84eab6f4.svg";